/**
 * Query-string builder for the list endpoints.
 *
 * Repeatable params (`?status=A&status=B`) are expressed as arrays — Spring binds
 * them to a `List<T>`. Empty strings, nulls, empty arrays and `undefined` are
 * dropped, so a cleared filter disappears from the URL instead of arriving as
 * `?q=` and matching everything-that-contains-nothing.
 */
export type QueryValue =
  | string | number | boolean | null | undefined
  | (string | number)[]

export function qs(params: Record<string, QueryValue>): string {
  const sp = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) continue
    if (Array.isArray(value)) {
      for (const v of value) {
        if (v === null || v === undefined || v === '') continue
        sp.append(key, String(v))
      }
      continue
    }
    if (value === '') continue
    sp.append(key, String(value))
  }
  const s = sp.toString()
  return s ? `?${s}` : ''
}

/** `/audit` + built query string. */
export function url(path: string, params: Record<string, QueryValue>): string {
  return path + qs(params)
}

/** Counts how many filters are actually narrowing, for the "Clear N filters" chip. */
export function countActive(params: Record<string, QueryValue>): number {
  let n = 0
  for (const value of Object.values(params)) {
    if (value === null || value === undefined || value === '') continue
    if (Array.isArray(value)) { if (value.length > 0) n += 1; continue }
    if (value === false) continue
    n += 1
  }
  return n
}
